import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type CurrentOrganization = { id: string | null };

const initialState: CurrentOrganization = { id: null };

export const currentOrganizationSlice = createSlice({
  name: 'viewer/me/set-current-organization',
  initialState,
  reducers: {
    setCurrentOrganization(state, action) {
      return {
        ...state,
        id: action.payload,
      };
    },
  },
});

const currentOrganization = (state: RootState) => state?.entities?.organizations?.currentOrganization;
const currentOrganizationSelector = createSelector(currentOrganization, state => state);

export const selectors = { currentOrganizationSelector };

export const actions = currentOrganizationSlice.actions;
export const reducer = currentOrganizationSlice.reducer;
